import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'qaroni-time-bank-summaries',
  templateUrl: './time-bank-summaries.component.html',
  styleUrl: './time-bank-summaries.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimeBankSummariesComponent {
  readonly label = input<string>('');
  readonly icon = input<string>('');
  readonly time = input<string>('');
}
